// Vue
import { Component, Watch, Vue, Prop } from "vue-property-decorator";
// Template
import template from "./template.vue";
// Components
import { Observer } from "mobx-vue";
import { Haendlersuche } from "../../../../components/haendlersuche/Haendlersuche";
import { Api } from "../../../../api";
import { BodyBuilderType } from "#/common/enums/conversionworld/BodyBuilder";

@Observer
@Component({
  mixins: [template],
  components: {
    Haendlersuche,
  },
})
export class OverviewMap extends Vue {
  @Prop()
  public translation!: object;

  @Prop({ default: "de" })
  public lang!: string;

  @Prop({ default: "" })
  public query!: string;

  private points: H.geo.IPoint[] = [];

  public mounted() {
    this.loadData();
  }

  @Watch("query")
  public onQueryChange() {
    this.loadData();
  }

  async created() {
    this.$eventBus.$on("conversion-world-close-filter", this.loadData);
  }

  public beforeDestroy() {
    this.$eventBus.$off("conversion-world-close-filter", this.loadData);
  }

  public get filter() {
    return this.$store.conversionWorldProductFilter.filterWithPageId;
  }

  public async loadData() {
    let result = await Api.conversionWorldService.getBodyBuilders(
      undefined,
      this.$store.conversionWorldProductFilter.filterWithPageId,
      {
        epp: -1,
        page_number: 0,
      }
    );
    let dataPoints: H.clustering.DataPoint[] = [];
    result.resultList.forEach((entry) => {
      dataPoints.push(
        new H.clustering.DataPoint(
          parseFloat(entry.location.lat),
          parseFloat(entry.location.lng),
          1,
          entry
        )
      );
    });

    this.points = dataPoints;
  }
}
